import { Action, Selector, State, StateContext } from '@ngxs/store';
import { switchMap, tap, pluck } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AppModuleManagement } from '../models';
import { AppModuleManagementService } from '../services/app-module-managemant.service';
import { CreateAppModule, UpdateAppModule, DeleteAppModule, GetAppModule, GetList } from '../actions/app-module-management.actions';


@State<AppModuleManagement.State>({
    name: 'AppModuleManagement',
    defaults: {
        modules: { items: [], totalCount: 0 }
    } as AppModuleManagement.State,
})
@Injectable()
export class AppModuleManagementState {

    @Selector()
    static appModules({ modules }: AppModuleManagement.State): AppModuleManagement.AppModuleItem[] {
        return modules.items;
    }

    @Selector()
    static appModuleTotalcount({ modules }: AppModuleManagement.State): number {
        return modules.totalCount;
    }


    constructor(private appModuleManagementService: AppModuleManagementService) {

    }

    @Action(CreateAppModule)
    createAppModule({ patchState, getState }: StateContext<AppModuleManagement.State>, { payload }: CreateAppModule) {
        let state = getState();
        return this.appModuleManagementService.create(payload).pipe(
            tap(
                createdItem => {
                    state.modules.items.push(createdItem);
                    state.modules.totalCount++;
                    patchState({
                        modules: { ...state.modules }
                    });
                }
            ),
        );
    }

    @Action(UpdateAppModule)
    updateAppModule({ patchState, getState }: StateContext<AppModuleManagement.State>, { payload }: UpdateAppModule) {
        let state = getState();
        return this.appModuleManagementService.update(payload).pipe(
            tap(
                updatedItem => {
                    let originalItem = state.modules.items.find(x => x.id == updatedItem.id);
                    originalItem = updatedItem;
                    patchState({
                        modules: { ...state.modules }
                    });
                }
            )
        )
    }

    @Action(DeleteAppModule)
    deleteAppModule(_, { id }: DeleteAppModule) {
        return this.appModuleManagementService.delete(id);
    }

    @Action(GetAppModule)
    select({ patchState }: StateContext<AppModuleManagement.State>, { id }: GetAppModule) {
        return this.appModuleManagementService.get(id).pipe(
            tap(
                item => patchState({
                    selected: item
                })
            ),
        );
    }

    @Action(GetList)
    getList({ patchState }: StateContext<AppModuleManagement.State>, { payload }: GetList) {
        return this.appModuleManagementService.list(payload)
            .pipe(
                tap(
                    response => patchState({
                        modules: response
                    })
                )
            );
    }
}